module.exports = __webpack_public_path__ + "img/no-results.3f31b4ef.svg";